module.exports = __webpack_public_path__ + "static/media/photo168.01e012b4.jpg";